// @ts-nocheck
import React from 'react';
import NoAppId from '../../../../common/NoAppId';
import AutoSelectText from '../../../../common/AutoSelectText';

function GameAppIdCell({ name, id, editable }) {
  return (
    <div className="grid-game-name num text-center">
      {id ? <AutoSelectText>{name}</AutoSelectText> : <NoAppId />}
    </div>
  );
}

export default GameAppIdCell;
